import { KortbetjeningText } from '@hooks/use-text';

import { MessageType } from './types';

export const getErrorTitle = (type: MessageType, dictionary: KortbetjeningText): string | undefined => {
    if (type === MessageType.COMING_SOON || type === MessageType.COMING_SOON_HIDDEN) {
        return dictionary.messageComingSoonTitle;
    }

    if (type === MessageType.ERROR_SERVER) {
        return dictionary.messageErrorText;
    }

    if (type === MessageType.EMPTY) {
        return dictionary.messageEmptyInformation;
    }

    if (type === MessageType.ERROR_PENDING) {
        return dictionary.messageErrorUps;
    }

    return undefined;
};

export const getErrorText = (type: MessageType, dictionary: KortbetjeningText): string | undefined => {
    if (type === MessageType.COMING_SOON || type === MessageType.COMING_SOON_HIDDEN) {
        return dictionary.messageComingSoonText;
    }

    if (type === MessageType.ERROR_SERVER) {
        return dictionary.messageErrorText2;
    }

    if (type === MessageType.ERROR_PENDING) {
        return dictionary.messageOrderCardPending;
    }

    return undefined;
};
